import React from 'react'
import { Link } from 'react-router-dom'

const InitiateAsmt = () => {
  return (
    <div className="lg:px-16 p-4">
      <div data-aos="fade-up" className="bg-white  rounded-lg  lg:flex justify-between items-center">
        {/* Text Section */}
        <div className="lg:w-1/2 w-full pl-4 flex flex-col bg-white shadow-md rounded-lg p-6">
          <h1  style={{ fontFamily: "Helvetica" }} className="text-3xl font-bold text-blue-800">Self Assess Your Executive Presence</h1>
          <p className="mt-2 text-gray-700 leading-relaxed">
            Evaluate your own executive presence based on how you perceive your strengths and areas of improvement. This assessment allows you to gain personal insights into how you communicate, lead, and inspire those around you.
          </p>

          <ul className="list-disc list-inside mt-4 text-gray-700">
            <li className="flex items-center">
              <span className="text-blue-600 mr-2">✔️</span>
              <strong>Reflect On Your Leadership Style</strong>
            </li>
            <li className="flex items-center">
              <span className="text-blue-600 mr-2">✔️</span>
              <strong>Understand Your Communication Effectiveness</strong>
            </li>
            <li className="flex items-center">
              <span className="text-blue-600 mr-2">✔️</span>
              <strong>Gain A Deeper Understanding of Your Executive Presence</strong>
            </li>
            <li className="flex items-center">
              <span className="text-blue-600 mr-2">✔️</span>
              <strong>Inspire Those Around You</strong>
            </li>
          </ul>

          {/* <p className="mt-4 text-blue-600 font-bold text-lg">Pricing Plan: Absolutely Free!</p>
          <p className="text-blue-600 font-bold text-lg">Our gift to evaluate and enhance your Executive Presence!</p> */}

          <Link to="/start-asmt">
            <button className="mt-6 px-8 py-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-all duration-300 ease-in-out shadow-lg hover:shadow-xl">
              Start Assessment
            </button>
          </Link>

          <div className="mt-4 p-4 bg-red-50 border-l-4 border-red-500 rounded">
            <p className="text-red-600 font-semibold">Pricing Plan: Absolutely Free! Our gift to evaluate and enhance your Executive Presence!</p>
          </div>
        </div>


        {/* Image Section */}
        <div data-aos="fade-up" className="lg:w-1/2 lg:p-5 mt-4 lg:mt-0">
          <img
            src="https://cdn.pixabay.com/photo/2015/05/31/15/14/woman-792162_1280.jpg"
            alt="A diverse group of people standing in a circle with their hands joined in the center, symbolizing teamwork and unity."
            className="rounded-lg"
          />
        </div>
      </div>

      <div data-aos="fade-up" className="bg-white  rounded-lg lg:flex justify-between items-center mt-8">
        <div className="lg:w-1/2 lg:p-5">
          <img
            src="https://images.pexels.com/photos/3184423/pexels-photo-3184423.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt="A diverse group of people standing in a circle with their hands joined in the center, symbolizing teamwork and unity."
            className="rounded-lg w-full h-[400px] object-cover"
          />
        </div>

        <div className="lg:w-1/2 w-full lg:mt-0 flex flex-col lg:justify-start lg:items-start bg-white shadow-md rounded-lg p-6">
          <h1   style={{ fontFamily: "Helvetica" }} className="text-3xl font-bold text-blue-800">360 Degree Assess Your Executive Presence</h1>

          <p className="mt-2 text-gray-700 leading-relaxed">
            Gain a holistic view of your executive presence by collecting feedback from peers, colleagues, and stakeholders. This comprehensive assessment gives you an outside perspective on how others perceive your leadership and impact.
          </p>

          <ul className="list-disc list-inside mt-4 text-gray-700">
            <li className="flex items-center">
              <span className="text-blue-600 mr-2">✔️</span>
              <strong>Gather multi-source feedback</strong>
            </li>
            <li className="flex items-center">
              <span className="text-blue-600 mr-2">✔️</span>
              <strong>Compare your self-perception with others' views</strong>
            </li>
            <li className="flex items-center">
              <span className="text-blue-600 mr-2">✔️</span>
              <strong>Receive an objective, well-rounded evaluation of your executive presence</strong>
            </li>
          </ul>

          <Link to="/start-asmt">
            <button className="mt-6 px-8 py-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-all duration-300 ease-in-out shadow-lg hover:shadow-xl">
              Start Assessment
            </button>
          </Link>

          <div className="mt-4 p-4 bg-red-50 border-l-4 border-red-500 rounded">
            <p className="text-red-600 font-semibold">Pricing Plan: Absolutely Free! Our gift to evaluate and enhance your Executive Presence!</p>
          </div>
        </div>

      </div>
    </div>

  )
}

export default InitiateAsmt